/* eslint-env es6 */
'use strict';

import AccountMenuItemController from 'contextmenu/account/account.controller';

export default new AccountMenuItemController();
